import React from 'react';
import { Helmet } from 'react-helmet';
import { getSiteConfig } from '../libs/common/siteConfig';

export function getPageMetadata({ title, description } = {}) {
  const siteConfig = getSiteConfig();
  const pageTitle = title || siteConfig.title;
  const pageDescription = description || siteConfig.description;
  const canonicalPath = typeof window !== 'undefined' ? window.location.pathname : siteConfig.defaultRoute;
  const canonicalUrl = `${siteConfig.siteUrl}${canonicalPath}`;
  const imageUrl = `${siteConfig.siteUrl}${siteConfig.ogImage}`;

  return {
    siteConfig,
    title: pageTitle,
    description: pageDescription,
    canonicalUrl,
    imageUrl,
  };
}

export function SiteMetadata({ title, description }) {
  const metadata = getPageMetadata({ title, description });
  const { siteConfig, canonicalUrl, imageUrl } = metadata;

  return (
    <Helmet>
      <title>{metadata.title}</title>
      <meta name="application-name" content={siteConfig.name} />
      <meta name="description" content={metadata.description} />
      <meta name="keywords" content={siteConfig.keywords} />
      <meta name="theme-color" content={siteConfig.themeColor} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteConfig.name} />
      <meta property="og:title" content={metadata.title} />
      <meta property="og:description" content={metadata.description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:secure_url" content={imageUrl} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={`${metadata.title} preview`} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metadata.title} />
      <meta name="twitter:description" content={metadata.description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={`${metadata.title} preview`} />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: metadata.title,
          description: metadata.description,
          url: canonicalUrl,
          image: imageUrl,
          applicationCategory: 'GameApplication',
          operatingSystem: 'Web',
        })}
      </script>
    </Helmet>
  );
}
